export const faqs = [
  {
    q: '¿Es un producto físico?',
    a: 'No. COMBO COMPLETO ELECTRICISTAS es un producto 100 % digital. Recibís acceso a sus materiales descargables después de completar tu compra.',
  },
  {
    q: '¿Para quién está pensado?',
    a: 'Está dirigido principalmente a electricistas domiciliarios, instaladores y profesionales con conocimientos previos que quieren contar con casos prácticos y herramientas de consulta para su actividad.',
  },
  {
    q: '¿Es un curso de electricidad desde cero?',
    a: 'No. El sistema se enfoca en diagnóstico de fallas, interpretación de circuitos, casos técnicos y herramientas profesionales. No está diseñado como una capacitación inicial.',
  },
  {
    q: '¿Qué tipo de fallas incluye?',
    a: 'Incluye casos relacionados con disyuntores, térmicas, tomacorrientes, iluminación, conexiones, instalaciones antiguas, humedad, cableado deteriorado y otras situaciones de diagnóstico domiciliario.',
  },
  {
    q: '¿Los casos incluyen soluciones?',
    a: 'Sí. Los casos desarrollan posibles causas, evidencia disponible, interpretación y medidas correctivas justificadas. En una instalación real, el diagnóstico debe confirmarse mediante las verificaciones correspondientes.',
  },
  {
    q: '¿Qué contienen los cuatro bonos?',
    a: 'Incluyen diagramas eléctricos, ejercicios de interpretación de mediciones, fichas profesionales de diagnóstico y herramientas para elaborar presupuestos.',
  },
  {
    q: '¿Puedo consultar el material desde el celular o imprimirlo?',
    a: 'Sí. Podés consultarlo desde el celular con una aplicación compatible, o desde una computadora o tablet. También podés imprimir los documentos para tu uso personal o profesional, según sus condiciones de licencia.',
  },
  {
    q: '¿Los recursos están adaptados a Argentina?',
    a: 'Sí. El contenido está redactado en español argentino y utiliza terminología habitual del sector eléctrico domiciliario del país.',
  },
  {
    q: '¿Tengo que pagar una suscripción mensual?',
    a: 'No. El combo se ofrece mediante un único pago, sin mensualidades por el acceso al material adquirido.',
  },
  {
    q: '¿Cómo recibo mi compra y qué hago si tengo un problema?',
    a: 'Una vez confirmado el pago, recibís las instrucciones de acceso y descarga mediante el sistema de entrega digital de la tienda. Si tenés algún inconveniente, escribinos a compradigitalyaa@gmail.com.',
  },
];
